module.exports = __webpack_public_path__ + "static/media/meeting_room.4aba7f59.svg";